import { inject, Injectable } from "@angular/core";
import { ArticleInfos } from "app/features/articles/models/article.model";
import { BehaviorSubject, Observable } from "rxjs";
import { ArticlesInfosFacadeService } from "app/features/articles/services/article-infos/article-infos-facade.service";

@Injectable({
  providedIn: "root",
})
export class HydrateService {
  facadeArticleInfos = inject(ArticlesInfosFacadeService);

  private _loading$ = new BehaviorSubject<boolean>(false);

  get loading$(): Observable<boolean> {
    return this._loading$.asObservable();
  }

  constructor() {}

  async hydrateAll() {
    this._loading$.next(true);

    await Promise.all([this.facadeArticleInfos.loadAll()])
      .then(() => {
        this._loading$.next(false);
      })
      .catch(() => {});
  }

  hydrateOneInfoArticle(infosArticle: ArticleInfos) {
    const store = this.facadeArticleInfos.store;
    const existing = store.getByArticleId(infosArticle.articleId);
    if (existing()) {
      store.removeOne(existing().id);
    }
    store.addOne(infosArticle);
  }
}
